import { useEffect, useState } from 'react';
import CitizensReportIcon from './images/citizens-report.svg';
import './Notifications.css';

export default function NotificationPopup({ notification, onClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);

    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300);
    }, 7000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className={`notification ${
        visible ? 'show' : 'hide'
      } notification-popup-container`}
    >
      <div
        style={{
          backgroundColor: notification.type === 0 ? '#079c6a' : '#fff',
        }}
        className="notification-popup-icon"
      >
        <img
          height={16}
          src={notification.type === 0 && CitizensReportIcon}
          alt=""
        />
      </div>

      <div className="notification-popup-text">
        <div className="notification-popup-title">
          {notification.type === 0 && 'Prijava građana'}
        </div>

        <div className="notification-popup-message">{notification.message}</div>
      </div>
    </div>
  );
}
